<template>
	<div class="section pride-cta-bar-container" ref="ctabar">
    <div class="cta-bar-bg">
      <ul>
        <li class="red"></li><li class="orange"></li><li class="yellow"></li><li class="green"></li><li class="blue"></li><li class="purple"></li>
      </ul>
    </div>
    <div>
      <h3 v-html="ctaBar.COPY"></h3>
    </div>
    <div>
    <a v-bind:href="ctaBar.BTN_LINK">
      <button v-html="ctaBar.BTN_COPY" class="pride-btn"></button>
    </a>
    </div>
  </div>
</template>

<script>

	import isIntersectingMixin from '../../mixins/isIntersectingMixin';

	export default {
		name: "pride-cta-bar",
    mixins: [isIntersectingMixin],

    props: {
      ctaBar: {
        type: Object,
      }
    },
		// data(){
		// 	return{
		// 		observer : null
		// 	}
		// },
		// mounted(){
		// 	this.observer = new IntersectionObserver(this.onIntersect, {
		// 		root: null,
		// 		rootMargin: '0px 0px 0px 0px',
		// 		threshold: .4,
		// 	});

		// 	this.observer.observe(this.$el)
		// 	},
		// 	destroyed(){
		// 		this.observer.disconnect()
		// 		this.observer = null
		// 	},
			methods: {
				onIntersect(event) {
					const ctabar = this.$refs.ctabar;
					const isIntersecting = event.find((entry) => {
						return entry.isIntersecting
					})
					if (isIntersecting) {
						this.$emit('intersect', event)
            ctabar.querySelectorAll('.cta-bar-bg  ul > li').forEach(el => {
              el.classList.add("active");
            });
					}
				},				
			}
  }
</script>

<style lang='scss' scoped>

  .pride-cta-bar-container {
    // background: linear-gradient(180deg, 
    //               #ec1c24 0%, 
    //               #ec1c24 16.6%, 
    //               #f68c1e 16.6%,  
    //               #f68c1e 33.2%, 
    //               #ffad5c 33.2%, 
    //               #ffad5c 49.8%, 
    //               #16b036 49.8%, 
    //               #16b036 66.4%,
    //               #3e62b0 66.4%, 
    //               #3e62b0 83%, 
    //               #6d459b 83%, 
    //               #6d459b 99.6%
    //             );
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    .cta-bar-bg {

      ul {
          list-style: none;
          padding: 0;
          margin: 0;

          li {

            padding: 0;
            margin: 0;
            height: 15px;
            background: #000000;

            &.red {
              &.active {
				        animation: red-bg-animation .5s 0s forwards;
			        }
            }

            &.orange {
              &.active {
				        animation: orange-bg-animation .5s .1s forwards;
			        }
            }

            &.yellow {
              &.active {
				        animation: yellow-bg-animation .5s .2s forwards;
			        }
            }

            &.green {
              &.active {
				        animation: green-bg-animation .5s .3s forwards;
			        }
            }

            &.blue {
              &.active {
				        animation: blue-bg-animation .5s .4s forwards;
			        }
            }

            &.purple {
              &.active {
				        animation: purple-bg-animation .5s .5s forwards;
			        }
            }
          }
      }

      position: absolute;
      z-index: -1;
      width: 100%;
      height: 100%;
      background-size: 100%;
    }

    @media (min-width: 768px) {
      flex-direction: row;
    }

    h3 {
      font-size: 20px;

      @media (min-width: 768px) {
        font-size: 28px;
        height: 28px;
      }
    }

    .pride-btn {
      margin: 0;

      @media (max-width: 768px) {
        font-size: 20px;
      }

      @media (min-width: 768px) {
        margin-left: 1em;
      }

    }

    @keyframes red-bg-animation {
      0% {background-color:#000000;}
      15%{background-color:#eb1c24;}
      100%{background-color:#eb1c24;}
    }

    @keyframes orange-bg-animation {
      0% {background-color:#000000;}
      15%{background-color:#f68c1e;}
      100%{background-color:#f68c1e;}
    }

    @keyframes yellow-bg-animation {
      0% {background-color:#000000;}
      15%{background-color: #ffad5c;}
      100%{background-color: #ffad5c;}
    }

    @keyframes green-bg-animation {
      0% {background-color:#000000;}
      15%{background-color: #16b036;}
      100%{background-color: #16b036;}
    }

    @keyframes blue-bg-animation {
      0% {background-color:#000000;}
      15%{background-color: #3e62b0;}
      100%{background-color: #3e62b0;}
    }

    @keyframes purple-bg-animation {
      0% {background-color:#000000;}
      15%{background-color: #6d459b;}
      100%{background-color: #6d459b;}
    }

  }


</style>


// WEBPACK FOOTER //
// src/components/pride/PrideCTABar.vue